import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HwTimeSecService {

  constructor() {
  }//constructor

  private seconds_in_minute = 60;
  private seconds_in_hour = 3600;
  private seconds_in_day = 86400;

  private SECONDS = 0;
  private MINUTES = 1;
  private HOURS = 2;
  private DAYS = 3;


  GetSeconds(seconds) {
    return seconds;
  }//GetMinutes

  GetMinutes(seconds) {
    return Math.trunc(seconds / this.seconds_in_minute);
  }//GetMinutes

  GetHours(seconds) {
    return Math.trunc(seconds / this.seconds_in_hour);
  }//GetHours

  GetDays(seconds) {
    return Math.trunc(seconds / this.seconds_in_day);
  }//GetHours


  GetTimeframe(seconds) {
    if (seconds < this.seconds_in_minute) {
      return this.SECONDS;
    }//HwTimeSec.SECONDS

    if (seconds < this.seconds_in_hour) {
      return this.MINUTES;
    }//HwTimeSec.SECONDS

    if (seconds < this.seconds_in_day) {
      return this.HOURS;
    }//HwTimeSec.HOURS

    return this.DAYS;
  };//GetTimeframe

  GetTimeFrameLoc(timeframe) {
    switch (timeframe) {
      case this.SECONDS:
        return 'sec';
      case this.MINUTES:
        return 'min';
      case this.HOURS:
        return 'hr';
      case this.DAYS:
        return 'd';
    }//switch
  }//GetTimeFrameLoc

  GetTimeFrameValue(timeframe, seconds) {
    switch (timeframe) {
      case this.SECONDS:
        return this.GetSeconds(seconds);
      case this.MINUTES:
        return this.GetMinutes(seconds);
      case this.HOURS:
        return this.GetHours(seconds);
      case this.DAYS:
        return this.GetDays(seconds);
    }//switch
  }//GetTimeFrameValue

  GetTimeSecLocalized(seconds) {
    const timeframe = this.GetTimeframe(seconds);
    const timeframe_localization = this.GetTimeFrameLoc(timeframe);
    const timeframe_value = this.GetTimeFrameValue(timeframe, seconds);

    return (timeframe_value + ' ' + timeframe_localization);
  }//GetTimeSecLocalized
}
